// Shared UK time formatting utilities — always Europe/London regardless of browser timezone

const UK_TZ = 'Europe/London';

/** Format a date/string as UK time: "11:03" or "11:03:45" */
export const formatUKTime = (dateInput, includeSeconds = false) => {
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '--:--';
  return d.toLocaleTimeString('en-GB', {
    timeZone: UK_TZ,
    hour: '2-digit',
    minute: '2-digit',
    ...(includeSeconds ? { second: '2-digit' } : {}),
  });
};

/** Format a date/string as UK date: "12/09/2026" */
export const formatUKDate = (dateInput) => {
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '--/--/----';
  return d.toLocaleDateString('en-GB', {
    timeZone: UK_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

/** Format as UK date + time: "12/09/2026 11:03" */
export const formatUKDateTime = (dateInput) => {
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '--/--/---- --:--';
  return d.toLocaleString('en-GB', {
    timeZone: UK_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Shift a JS Date into a "fake-local" Date that, when passed to date-fns format(),
 * prints UK wall-clock digits correctly.
 * Only needed for date-fns format() calls — use formatUKTime/formatUKDate where possible.
 */
export const toUKDate = (dateInput) => {
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return d;
  // Compute UK offset vs UTC at this instant
  const utcMs  = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());
  const ukParts = new Intl.DateTimeFormat('en-GB', {
    timeZone: UK_TZ,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }).formatToParts(d);
  const get = (type) => parseInt(ukParts.find(p => p.type === type)?.value || '0', 10);
  return new Date(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
};
